import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CiCircleCheck } from "react-icons/ci";
import Image from "next/image";
import { useEnquire } from "../Enquire/useEnquireStore";
import { CourseContentLayout } from "@/services/types";

const TitleMedicine = "Study Medicine in Europe in English";
const TitleDentistry = "Study Dentistry in Europe in English";
const TitlePharmacy = "Study Pharmacy in Europe In English";
const TitleVeterinary = "Study Veterinary in Europe in English";
const TitleFoundation = "Medicine Foundation Courses Europe";

const questionMedicine = "Why Pursue Your Medical Education In Europe?";
const questionDentistry = "Why Pursue Your Dental Degree in Europe?";
const questionPharmacy = "Why Pursue Your Pharmacy Degree In Europe?";
const questionVeterinary = "Why Pursue Your Veterinary Degree In Europe?";
const questionFoundation = "Why Pursue Medical Education in Europe?";

const ArrNoteMedicine = [
  "Veterinary medicine courses fully taught in English",
  "100% Guaranteed acceptance",
  "Affordable living costs and tuition fees",
  "Excellently organised high quality courses",
  "Full ongoing support throughout your studies",
  "Recognised by WHO and listed in World Directory of Medical Schools",
];

const ArrNoteDentistry = [
  "Dentistry courses fully taught in English",
  "Recognised by the WHO and listed in the World Directory of Medical Schools",
  "DMD degree recognised by UK General Dental Council & Medical Councils worldwide",
  "100% guaranteed acceptance into dental school",
  "Affordable tuition fees & cost of living",
  "Full ongoing support by doctors and students overseas",
];

const ArrNotePharmacy = [
  "Pharmacy courses fully taught in English",
  "Recognised by the WHO and listed in the World Directory of Medical Schools",
  "Wide range of opportunities after graduation",
  "Low living costs and tuition fees",
  "100% globally recognised diploma",
  "Modern facilities and experienced teachers",
];

const ArrNoteVeterinary = [
  "Veterinary medicine courses fully taught in English",
  "100% Guaranteed acceptance",
  "Affordable living costs and tuition fees",
  "Excellently organised high quality courses",
  "Full ongoing support throughout your studies",
  "Recognised by WHO and listed in World Directory of Medical Schools",
];

const ArrNoteFoundation = [
  "Significantly higher chance for entry into year 1",
  "Affordable foundation course medicine",
  "Low entry requirements",
  "Gain A-Level science knowledge",
];

type BannerPostComponentProps = {
  urlBanner: string;
  data?: CourseContentLayout;
};

const RatingData = [
  {
    start: [1, 2, 3, 4, 5],
    socialNetwork: "TrustPilot",
  },
  {
    start: [1, 2, 3, 4, 5],
    socialNetwork: "Google",
  },
  {
    start: [1, 2, 3, 4, 5],
    socialNetwork: "Facebook",
  },
];

const AdvantageData = [
  {
    urlImage: "/assets/posticon/globe.png",
    title: "Globally",
    note: "Recognised Courses",
  },
  {
    urlImage: "/assets/posticon/translation.png",
    title: "English",
    note: "Taught Programs",
  },
  {
    urlImage: "/assets/posticon/directions.png",
    title: "Flexible",
    note: "Admission Requirements",
  },
  {
    urlImage: "/assets/posticon/tuition.png",
    title: "Affordable",
    note: "Tuition Fees, Living Costs",
  },
  {
    urlImage: "/assets/posticon/exam.png",
    title: "Unlimited",
    note: "University Applications",
  },
  {
    urlImage: "/assets/posticon/competition.png",
    title: "Less",
    note: "Competition For Entry",
  },
  {
    urlImage: "/assets/posticon/medical-record.png",
    title: "Modern",
    note: "Facilities & Technology",
  },
  {
    urlImage: "/assets/posticon/monitor.png",
    title: "Work",
    note: "Return Home, Start Practicing",
  },
];

const BannerPostComponent = (props: BannerPostComponentProps) => {
  const { data, urlBanner } = props;
  const { setOpen } = useEnquire();
  return (
    <Box>
      <Box
        sx={{
          py: (theme) => theme.customLayout.py,
          px: (theme) => theme.customLayout.px,
        }}
      >
        <Grid container spacing={2}>
          <Grid size={{ md: 6, xl: 6 }}>
            <Box>
              <Typography
                variant="h1"
                sx={{
                  fontSize: "48px",
                  lineHeight: "56px",
                  fontWeight: 700,
                  letterSpacing: "-0.03em",
                  textAlign: "left",
                  textUnderlinePosition: "from-font",
                  textDecorationDkipInk: "none",
                }}
              >
                {data?.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 400,
                  letterSpacing: "-0.03em",
                  textAlign: "left",
                  textUnderlinePosition: "from-font",
                  textDecorationDkipInk: "none",
                  margin: "20px 0",
                }}
              >
                Just choose your desired course. Let us take care of the rest
                for you.
              </Typography>
              <Box>
                {data?.note.map((x, index) => {
                  return (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      <CiCircleCheck fontSize={30} />
                      <Typography
                        variant="h1"
                        sx={{
                          fontSize: "16px",
                          lineHeight: "24px",
                          fontWeight: 500,
                          textAlign: "left",
                          textUnderlinePosition: "from-font",
                          textDecorationDkipInk: "none",
                          marginLeft: "10px",
                        }}
                      >
                        {x}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
              <Button
                variant="contained"
                onClick={() => setOpen(true)}
                sx={{
                  background: "#101828",
                  color: "#FFFFFF",
                  fontSize: "16px",
                  lineHeight: "20px",
                  fontWeight: 700,
                  padding: "12px 20px",
                  borderRadius: "25px",
                  textTransform: "none",
                  marginTop: "32px",
                  "&:hover": {
                    opacity: 0.8,
                  },
                }}
              >
                <label style={{ marginRight: "8px" }}>
                  {`enquire now for free`.toUpperCase()}
                </label>
                <Image
                  src="/assets/common/ArrowRight.png"
                  alt={`NextArrow`}
                  width={5}
                  height={10}
                />
              </Button>
              <Box sx={{ marginTop: "20px" }}>
                {RatingData.map((rating, index) => {
                  return (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        margin: "10px 0",
                      }}
                    >
                      {rating.start.map((x, index) => {
                        return <span key={index}>⭐</span>;
                      })}
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "14px",
                          lineHeight: "24px",
                          fontWeight: 400,
                          letterSpacing: "-0.03em",
                          textAlign: "left",
                          textUnderlinePosition: "from-font",
                          textDecorationDkipInk: "none",
                          marginLeft: "10px",
                        }}
                      >
                        {rating.start.length}/5 on {rating.socialNetwork}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Grid>
          <Grid size={{ md: 6, xl: 6 }}>
            <Box
              component="img"
              src={urlBanner}
              alt="Banner post"
              style={{
                width: "100%",
                height: "auto",
                padding: "5px",
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: "center" }}>
            <Typography
              variant="body1"
              sx={{
                fontSize: "32px",
                lineHeight: "40px",
                fontWeight: 500,
                letterSpacing: "-0.03em",
                textAlign: "center",
                textUnderlinePosition: "from-font",
                textDecorationDkipInk: "none",
                margin: "100px 0 50px 0",
              }}
            >
              {data?.question}
            </Typography>
          </Grid>
          {AdvantageData.map((item, index) => {
            return (
              <Grid
                size={{ xs: 6, md: 3 }}
                key={index}
                sx={{ textAlign: "center" }}
              >
                <Box
                  component="img"
                  src={item.urlImage}
                  alt="Banner post"
                  width={{ xs: "50%", sm: "30%" }}
                  style={{
                    height: "auto",
                    padding: "20px",
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "24px",
                    lineHeight: "32px",
                    fontWeight: 700,
                    letterSpacing: "-0.03em",
                    textUnderlinePosition: "from-font",
                    textDecorationDkipInk: "none",
                    margin: "0 0 5px 0",
                    color: "#101828",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 500,
                    letterSpacing: "-0.03em",
                    textUnderlinePosition: "from-font",
                    textDecorationDkipInk: "none",
                  }}
                >
                  {item.note}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <Box
        sx={{
          py: (theme) => theme.customLayout.py,
          px: (theme) => theme.customLayout.px,
          backgroundColor: "#004238",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{ backgroundColor: "#fff", padding: "40px" }}
        >
          <Grid size={{ md: 10, xl: 10 }} sx={{ alignContent: "center" }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: "48px",
                lineHeight: "56px",
                fontWeight: 700,
                letterSpacing: "-0.03em",
                textAlign: "left",
                textUnderlinePosition: "from-font",
                textDecorationDkipInk: "none",
              }}
            >
              Schedule A FREE Consultation With An Expert Student Advisor
            </Typography>
          </Grid>
          <Grid
            size={{ md: 2, xl: 2 }}
            sx={{ alignContent: "center", textAlign: "left" }}
          >
            <Button
              variant="contained"
              onClick={() => setOpen(true)}
              sx={{
                background: "#101828",
                color: "#FFFFFF",
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: 700,
                padding: "12px 20px",
                borderRadius: "25px",
                textTransform: "none",
                "&:hover": {
                  opacity: 0.8,
                },
              }}
            >
              <label style={{ marginRight: "8px" }}>
                {`enquire now for free`.toUpperCase()}
              </label>
              <Image
                src="/assets/common/ArrowRight.png"
                alt={`NextArrow`}
                width={5}
                height={10}
              />
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default BannerPostComponent;
